import React, { useEffect, useRef, useState } from "react";
import { FiVolume2, FiVolumeX, FiGrid } from "react-icons/fi";
import MiniGLBViewer from "../pages/Spaceship";
import Timeline from "./timeline";
import ScenePicker, { BG_LINKS } from "./scence"; // ← 从 scene.js 导入 BG_LINKS
import ParallelTimeline from './parallel';
import './parallel.css';  // 确保样式能被加载

export default function Angel4({ children }) {
  const [current, setCurrent] = useState(0);
  const [bgInteractive, setBgInteractive] = useState(true);
  const [showPicker, setShowPicker] = useState(false);
  const audioRef = useRef(null);
  const [muted, setMuted] = useState(false);
  const [volume, setVolume] = useState(0.15);

  useEffect(() => {
    const a = new Audio("/sounds/");
    a.loop = true;
    a.volume = volume;
    a.muted = muted;
    audioRef.current = a;
    a.play().catch(() => {});
    return () => {
      a.pause();
      a.src = "";
    };
  }, [volume, muted]);

  const onVolume = e => {
    const v = +e.target.value;
    setVolume(v);
    if (!muted) audioRef.current.volume = v;
  };

  const toggleMute = () => {
    audioRef.current.muted = !audioRef.current.muted;
    setMuted(audioRef.current.muted);
  };

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("bg-interactive", { detail: bgInteractive }));
  }, [bgInteractive]);

  const popoverRef = useRef(null);
  useEffect(() => {
    if (!showPicker) return;
    const handleClickOutside = e => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setShowPicker(false);
      }
    };
    window.addEventListener("mousedown", handleClickOutside);
    return () => window.removeEventListener("mousedown", handleClickOutside);
  }, [showPicker]);

  return (
    <div style={{ position: "relative", minHeight: "100vh", width: "100%", overflow: "hidden", background: "#fff" }}>

        <div className="left-timeline-container">
        <Timeline />
     </div>

     <ParallelTimeline
       branches={[
         { time: 0.2, isKey: false },
         { time: 0.4, isKey: false },
         { time: 0.55, isKey: false, isBranch: true },
         { time: 0.6, isKey: false },
         { time: 0.75, isKey: true },
         { time: 0.9, isKey: false },
       ]}
       onSelect={(idx) => {
         // 切换对应分支的逻辑，例如：
         console.log('切换到分支', idx);
       }}
     />

      {/* 顶部控制 */}
      <div style={{ position: "fixed", top: "4rem", right: "1rem", zIndex: 250, display: "flex", gap: 8 }}>
        <button onClick={() => setShowPicker(!showPicker)} style={{ padding: 8, background: "rgba(0,0,0,0.55)", border: "none", borderRadius: 4, color: "#fff" }}>
          <FiGrid size={18} />
        </button>
        <button onClick={() => setBgInteractive(!bgInteractive)} style={{ padding: "6px 10px", fontSize: 12, border: "none", borderRadius: 4, background: "rgba(0,0,0,0.55)", color: "#fff" }}>
          {bgInteractive ? "Lock" : "Unlock"}
        </button>
      </div>

      {/* 背景选择弹窗 */}
      <ScenePicker
        links={BG_LINKS}
        current={current}
        setCurrent={setCurrent}
        showPicker={showPicker}
        setShowPicker={setShowPicker}
      />

      {/* 背景 iframe */}
      <div style={{ position: "fixed", inset: 0, zIndex: 0, overflow: "hidden" }}>
        <iframe
          key={current}
          src={BG_LINKS[current].url}
          title={`bg-${current}`}
          frameBorder="0"
          allow="autoplay; fullscreen; xr-spatial-tracking"
          style={{ position: "absolute", top: "50%", left: "50%", width: "120%", height: "120%", transform: "translate(-50%,-50%)", pointerEvents: bgInteractive ? "none" : "auto" }}
        />
      </div>

      {/* 小模型 */}
      <div style={{ position: "fixed", bottom: 88, left: 20, width: 64, height: 64, zIndex: 150 }}>
        <MiniGLBViewer url="/models/spaceship.glb" />
      </div>

      {/* 音量和静音 */}
      <div style={{ position: "fixed", bottom: 20, left: 20, display: "flex", gap: 8, zIndex: 900 }}>
        <button onClick={toggleMute} style={{ background: "rgba(0,0,0,0.35)", border: "none", borderRadius: 4, padding: 8, color: "#fff" }}>
          {muted ? <FiVolumeX size={20} /> : <FiVolume2 size={20} />}
        </button>
        <input type="range" min="0" max="1" step="0.01" value={muted ? 0 : volume} onChange={onVolume} style={{ width: 90 }} />
      </div>

      {/* 业务 UI 层 */}
      <div style={{ position: "relative", zIndex: 100, width: "100%", height: "100%", pointerEvents: "none" }}>
        {children}
      </div>
    </div>
  );
}
